let _apiEndpoint = "";

// Allow direct override via REACT_APP_API_ENDPOINT
if (process.env.REACT_APP_API_ENDPOINT) {
  _apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
} else if (process.env.REACT_APP_ENV === "production") {
  _apiEndpoint =
    "https://i6vumwk0sc.execute-api.eu-west-1.amazonaws.com/production";
} else if (process.env.REACT_APP_ENV === "testing") {
  _apiEndpoint =
    "https://5hwq4bzfnh.execute-api.eu-west-1.amazonaws.com/testing";
} else if (process.env.REACT_APP_ENV === "americas") {
  _apiEndpoint =
    "https://nu8q765krl.execute-api.eu-west-1.amazonaws.com/americas";
} else {
  _apiEndpoint = "http://localhost:8000";
}

export const apiEndpoint = _apiEndpoint;
